import getClientTree from './getClientTree'
import getClientDetail from './getClientDetail'
import sendFormC57 from './sendFormC57'
import updateMallaPropiedad from './updateMallaPropiedad'

export const getClientTreePromise = getClientTree
export const getClientDetailPromise = getClientDetail
export const sendFormC57Promise = sendFormC57
export const updateMallaPropiedadPromise = updateMallaPropiedad